var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46307 0.307991C2.05242 -0.102664 1.38662 -0.102664 0.97596 0.307991C0.565305 0.718646 0.565305 1.38445 0.97596 1.7951L6.18086 7L0.97596 12.2049C0.565305 12.6156 0.565305 13.2814 0.97596 13.692C1.38662 14.1027 2.05242 14.1027 2.46307 13.692L7.66797 8.48711L12.8729 13.692C13.2835 14.1027 13.9493 14.1027 14.36 13.692C14.7706 13.2814 14.7706 12.6156 14.36 12.2049L9.15508 7L14.36 1.7951C14.7706 1.38445 14.7706 0.718647 14.36 0.307991C13.9493 -0.102664 13.2835 -0.102663 12.8729 0.307991L7.66797 5.51289L2.46307 0.307991Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0e33e584fc93ce459a3cdfb1dbcf97f8.svg";
export { ForwardRef as ReactComponent };